import trackElementSettingsDialogDisplayed from './track-element-settings-dialog-displayed';
import trackElementSettingsDialogSubmitted from './track-element-settings-dialog-submitted';
import trackElementSettingsDialogCanceled from './track-element-settings-dialog-canceled';
import trackElementSettingsOptionClicked from './track-element-settings-option-clicked';
import trackElementSettingsSectionToggleClicked from './track-element-settings-section-toggle-clicked';

export default {
  trackElementSettingsDialogDisplayed,
  trackElementSettingsDialogSubmitted,
  trackElementSettingsDialogCanceled,
  trackElementSettingsOptionClicked,
  trackElementSettingsSectionToggleClicked,
};
